import * as z from 'zod';
import { RectangleSchema } from '../../graphics/common.ts';
import { BoneNameSchema, ConditionSchema } from '../../graphics/conditions.ts';
import { LayerImageSettingSchema, LayerMirrorSchema, LayerNormalDataSchema, LayerPrioritySchema, LayerStateOverridesSchema } from '../../graphics/layers/common.ts';

export const GraphicsSourceMeshLayerSchema = RectangleSchema.extend({
	type: z.literal('mesh'),
	/** If configured, then this condition needs to be satisfied for this layer to display. */
	enableCond: ConditionSchema.optional(),
	name: z.string(),
	priority: LayerPrioritySchema,
	points: z.string(),
	pointType: z.string().array().optional(),
	/** Overrides applied to this layer while generating an item preview. */
	previewOverrides: LayerStateOverridesSchema.optional(),
	/** If true, this layer is hidden in the editor preview while the preview cutter's "Hide face" option is enabled. */
	previewHideFace: z.boolean().optional(),
	mirror: LayerMirrorSchema,
	colorizationKey: z.string().optional(),

	normalMap: LayerNormalDataSchema.optional(),
	image: LayerImageSettingSchema,
	scaling: z.object({
		scaleBone: BoneNameSchema,
		stops: z.array(z.tuple([z.number(), LayerImageSettingSchema])),
	}).optional(),
}).strict();
export type GraphicsSourceMeshLayer = z.infer<typeof GraphicsSourceMeshLayerSchema>;
